import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CompareCartService } from '@cart/data-access';
import { SdModal, SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { ButtonThemes } from '@shared/v2';
import { CartModification } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompareCartProductItemComponent } from './compare-cart-product-item';

@Component({
  selector: 'sd-compare-cart',
  templateUrl: './compare-cart.component.html',
  styleUrls: ['./compare-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, SdvorButtonComponent, CompareCartProductItemComponent],
})
export class CompareCartComponent implements OnInit {
  buttonThemes = ButtonThemes;
  productItemsStock$: Observable<CartModification[]>;
  productItemsPrice$: Observable<CartModification[]>;
  isMobile$ = this.deviceService.isMobileSmDown$;

  constructor(
    private compareCartService: CompareCartService,
    private deviceService: DeviceService,
    private sdModal: SdModal,
  ) {}

  ngOnInit(): void {
    this.productItemsStock$ = this.getDiffByStatusCodes(['lowStock', 'noStock']);
    this.productItemsPrice$ = this.getDiffByPrice();
  }

  confirmNewCart(): void {
    this.compareCartService.confirmNewCart();
    this.closeModal();
  }

  closeModal(): void {
    this.sdModal.close();
  }

  private getDiffByPrice(): Observable<CartModification[]> {
    return this.compareCartService.getDiff().pipe(map((diff) => diff.cartModifications.filter((i) => i.priceChanged)));
  }

  private getDiffByStatusCodes(statusCodes: string[]): Observable<CartModification[]> {
    return this.compareCartService
      .getDiff()
      .pipe(map((diff) => diff.cartModifications.filter((i) => statusCodes.includes(i.statusCode))));
  }
}
